module.exports = __webpack_public_path__ + "img/homepage-approve.d889a9c.svg";